/* istanbul ignore file */

/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { EfficiencyFlagListFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { EfficiencyFlagListFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { getDownloadItemFragmentedData } from '../DownloadItem/mockdata';

export const efficiencyFlagListDataMock: EfficiencyFlagListFragmentFragment = {
  tireEfficiency: {
    link: 'https://bilder.baur.de/i/empiriecom/a1456700f060227b89beaf41b9f08e5e.jpg',
    flags: [
      {
        type: 'FUELEFFICIENCY',
        level: 'C',
      },
      {
        type: 'WETGRIP',
        level: 'B',
      },
      {
        type: 'EXTERNALROLLINGNOISE',
        level: 'B | 71 dB',
      },
    ],
  },
  powerEfficiencyFlags: [
    {
      color: 'yellow',
      hasOldLabel: true,
      level: 'A',
      link: 'https://bilder.baur.de/i/empiriecom/66bff03e468d78b4cf1e5b1eff56481d.jpg',
      text: 'Backofen',
    },
    {
      color: 'lightorange',
      hasOldLabel: true,
      level: 'B',
      link: 'https://bilder.baur.de/i/empiriecom/653f583a57328668c7b1a178157e4990.jpg',
      text: 'Dunstabzugshaube',
    },
    {
      color: 'yellow',
      hasOldLabel: false,
      level: 'D',
      link: 'https://bilder.baur.de/i/empiriecom/7a3a619177ed6dd0b9745e21675c1360.jpg',
      text: 'Geschirrspüler',
    },
    {
      color: 'lightorange',
      hasOldLabel: false,
      level: 'E',
      link: 'https://bilder.baur.de/i/empiriecom/3989b5e66354eebed6f6c1e660afebb8.jpg',
      text: 'Kühlschrank',
    },
    {
      color: 'yellow',
      hasOldLabel: true,
      text: 'Backofen',
      level: 'A',
      link: 'https://bilder.baur.de/i/empiriecom/abf4d9e8885486c697664e8c0490ea1e',
    },
  ],
  downloads: [
    { ...getDownloadItemFragmentedData(), type: 'PRODUCT_DATASHEET' },
    { ...getDownloadItemFragmentedData(), type: 'ASSEMBLY_INSTRUCTIONS' },
  ],
};

export function getEfficiencyFlagListFragmentedData(data?: EfficiencyFlagListFragmentFragment) {
  return makeFragmentData(
    data || efficiencyFlagListDataMock,
    EfficiencyFlagListFragmentFragmentDoc,
  );
}
